import React, { FC } from 'react';
import { IConfig } from '../../../types/config';
import { IArticle } from '../../../types/article';
import { IArticlesRecommended2 } from './params';
import Styles from './styles';
import ArticleBox from '../../../components/ArticleBox';
import { common } from '../../../translates';

const ArticlesRecommended: FC<{ config: IConfig; articles: IArticle[]; language: string }> = ({
  config,
  articles,
  language,
}) => (
  <Styles $config={config.general.articlesRecommended.params as IArticlesRecommended2}>
    <div className="articles-recommended">
      <h3 className="articles-recommended-header">{common[language].sectionArticlesRecommended}</h3>
      <div className="articles-recommended-list">
        {articles.slice(2).map((article) => (
          <div key={article.id} className="articles-recommended-category">
            <ArticleBox language={language} config={config} article={article} withCategory={true} />
          </div>
        ))}
      </div>
    </div>
  </Styles>
);

export default ArticlesRecommended;
